<script setup lang="ts">
import SessionShort from '@/vue/organisms/session-short.vue';
import {useInterventionStore} from '@/ts/store/intervention-store';
import {useDragToScroll} from '@/ts/composables/pure/use-drag-to-scroll';
import {useScreenSize} from '@/ts/composables/stateful/use-screen-size';

const intervention = useInterventionStore();
const {scrollAreaRef, onMouseDown} = useDragToScroll();
const {isMobileResolution} = useScreenSize();

</script>
<template>
  <!-- Mobile/Tablet: native scroll, no q-scroll-area -->
  <div v-if="isMobileResolution" class="scrollable">
    <session-short
      v-for="session in intervention!.sessions"
      :key="session.id"
      :session-id="session.id"
    />
    <div class="end-spacer"/>
  </div>
  <!-- Desktop: q-scroll-area for mouse drag carousel -->
  <q-scroll-area v-else ref="scrollAreaRef" class="intervention-sessions-page">
    <div class="scrollable" @mousedown="onMouseDown">
      <session-short
        v-for="session in intervention!.sessions"
        :key="session.id"
        :session-id="session.id"
      />
      <div class="end-spacer"/>
    </div>
  </q-scroll-area>
</template>
<style lang="scss" scoped>
.intervention-sessions-page {
  width: 100%;
  height: calc(100% - var(--Spacing-spacing-3));
  min-height: 0;
  margin-bottom: var(--Spacing-spacing-3);

  // Quasar's container is position:absolute filling the scroll area.
  // Use display:grid on the content wrapper so it stretches to fill
  // available height, while still growing beyond to trigger vertical scroll.
  :deep(.q-scrollarea__content) {
    min-height: 100%;
    display: grid;
  }
}

.scrollable {
  display: flex;
  gap: var(--Spacing-spacing-4);
  padding: 0 0 var(--Spacing-spacing-13) 0;
  flex-direction: column;

  @include screen-md {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    scroll-snap-type: none;
    margin-left: calc(var(--Spacing-spacing-6) * -1);
    margin-right: calc(var(--Spacing-spacing-6) * -1);
    padding-left: var(--Spacing-spacing-6);
    padding-right: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  @include screen-lg {
    overflow-x: visible;
    overflow-y: visible;
    scrollbar-width: auto;
    margin-left: 0;
    margin-right: 0;
    padding: 4px 4px var(--Spacing-spacing-3) 4px;
    cursor: grab;
    user-select: none;

    &::-webkit-scrollbar {
      display: initial;
    }
  }
}

.scrollable :deep(.session) {
  @include screen-md {
    flex: 0 0 auto;
    width: 350px;
  }
}

.end-spacer {
  display: none;

  @include screen-md {
    display: block;
    flex: 0 0 auto;
    width: var(--Spacing-spacing-6);
  }
}
</style>
